import { ThemeDefinition } from 'vuetify';

export const physics: ThemeDefinition = {
  dark: false,
  colors: {
    'subject-original': '#5CC7BB',
    'on-subject-original': '#FFFFFF',
    subject: '#148578',
    'on-subject': '#FFFFFF',
    primary: '#215F58',
    'on-primary': '#FFFFFF',
    'primary-container': '#C6EBE7',
    'on-primary-container': '#102E2A',
    secondary: '#435B58',
    'on-secondary': '#FFFFFF',
    'secondary-container': '#D3DEDD',
    'on-secondary-container': '#1A2322',
    surface: '#F7FCFC',
    'on-surface': '#1D2020',
    'on-surface-medium': '#49504F',
    'on-surface-low': '#949E9D',
    outline: '#798684',
    'outline-variant': '#C9CFCE',
    'inverse-surface': '#24423F',
    'inverse-on-surface': '#EEF6F5',
    'inverse-primary': '#B3E5DF',
    'surface-dim': '#C2EBE6',
    'surface-bright': '#FBFEFD',
    'surface-container-lowest': '#FFFFFF',
    'surface-container-low': '#F0FAF9',
    'surface-container': '#E8F7F6',
    'surface-container-high': '#D9F2EF',
    'surface-container-highest': '#D1F0EC',
  },
};

export const physicsDark: ThemeDefinition = {
  dark: true,
  colors: {
    'subject-original': '#5CC7BB',
    'on-subject-original': '#F7FCFC',
    subject: '#7AD1C7',
    'on-subject': '#102D2A',
    primary: '#B3E5DF',
    'on-primary': '#102D2A',
    'primary-container': '#1F5B54',
    'on-primary-container': '#ECF8F7',
    secondary: '#C4D4D2',
    'on-secondary': '#1A2322',
    'secondary-container': '#364947',
    'on-secondary-container': '#F0F4F4',
    surface: '#101818',
    'on-surface': '#F2F3F3',
    'on-surface-medium': '#C9CFCE',
    'on-surface-low': '#798684',
    outline: '#949E9D',
    'outline-variant': '#616B6A',
    'inverse-surface': '#DEEDEB',
    'inverse-on-surface': '#152826',
    'inverse-primary': '#1A4C46',
    'surface-dim': '#0E1515',
    'surface-bright': '#2F4644',
    'surface-container-lowest': '#0C1212',
    'surface-container-low': '#141F1D',
    'surface-container': '#1B2826',
    'surface-container-high': '#233432',
    'surface-container-highest': '#2D4341',
  },
};
